<div class="bg-white rounded-lg w-fit">
  <p-button [label]="'View TA Event History'"
            [severity]="'primary'"
            outlined
            [icon]="'fa fa-list'"
            (onClick)="openEventHistory()"
  ></p-button>
</div>
